import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useCallback } from 'react';
import createContainer from 'constate';

function useShuttleAnimationState() {
  var _useState = useState({
    isMoving: false,
    isMovingBack: false,
    isDrillingDown: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      animationState = _useState2[0],
      setAnimationState = _useState2[1];

  var reset = useCallback(function () {
    return setAnimationState({
      isMoving: false,
      isMovingBack: false,
      isDrillingDown: false
    });
  }, []);
  var move = useCallback(function () {
    return setAnimationState({
      isMovingBack: false,
      isMoving: true,
      isDrillingDown: false
    });
  }, []);
  var moveBack = useCallback(function () {
    return setAnimationState({
      isMovingBack: true,
      isMoving: false,
      isDrillingDown: false
    });
  }, []);
  var drilldown = useCallback(function () {
    return setAnimationState({
      isMovingBack: false,
      isMoving: false,
      isDrillingDown: true
    });
  }, []);
  return {
    state: animationState,
    setIsMoving: move,
    setIsMovingBack: moveBack,
    setIsDrillingDown: drilldown,
    reset: reset
  };
}

var AnimationContext = createContainer(useShuttleAnimationState, function (value) {
  return [value.state];
});

export default AnimationContext;
//# sourceMappingURL=AnimationState.js.map
